export const translations = {
  en: {
    // App title and navigation
    appTitle: 'ECHO',
    appSubtitle: 'Patient Communication',
    quickButtons: 'Quick Buttons',
    bodyMap: 'Body Map',
    painScale: 'Pain Scale',
    sensations: 'Sensations',
    medications: 'Medications',
    visitors: 'Visitors',
    dashboard: 'Dashboard',
    reports: 'Reports',
    kidsMode: 'Kids Mode',
    settings: 'Settings',

    // Navigation labels
    navHome: 'Home',
    navBody: 'Body',
    navVoice: 'Voice',
    navComfort: 'Comfort',
    navNotes: 'Notes',
    navDocs: 'Documents',
    navVisitors: 'Visitors',
    navMeds: 'Medications',
    navDashboard: 'Dashboard',

    // Screen announcements
    screenHome: 'Home Screen',
    screenBody: 'Body Map Screen',
    screenVoice: 'Voice Control Screen',
    screenComfort: 'Comfort Controls Screen',
    screenNotes: 'Notes Screen',
    screenDocs: 'Documents Screen',
    screenVisitors: 'Visitor Log Screen',
    screenMeds: 'Medication Tracker Screen',
    screenDashboard: 'Caregiver Dashboard Screen',

    // Quick button labels
    emergency: 'Emergency',
    pain: 'Pain',
    help: 'Help',
    okay: "I'm Okay",
    thirsty: 'Thirsty',
    hungry: 'Hungry',
    bathroom: 'Bathroom',
    hot: 'Too Hot',
    cold: 'Too Cold',
    dizzy: 'Dizzy',
    tired: 'Tired',
    anxious: 'Anxious',

    // Quick button descriptions
    emergencyDesc: 'I need immediate help!',
    painDesc: 'I am in pain',
    helpDesc: 'I need assistance',
    okayDesc: 'I am doing okay',
    thirstyDesc: 'I need water',
    hungryDesc: 'I am hungry',
    bathroomDesc: 'I need the bathroom',
    hotDesc: 'I feel too hot',
    coldDesc: 'I feel too cold',
    dizzyDesc: 'I feel dizzy',
    tiredDesc: 'I am tired',
    anxiousDesc: 'I feel anxious',

    // Body map
    selectBodyPart: 'Select where it hurts',
    externalBody: 'External Body',
    internalOrgans: 'Internal Organs',
    tapToSelect: 'Tap a body part to select',
    selected: 'Selected',

    // External body parts
    head: 'Head',
    neck: 'Neck',
    chest: 'Chest',
    abdomen: 'Abdomen',
    stomach: 'Stomach',
    leftArm: 'Left Arm',
    rightArm: 'Right Arm',
    leftHand: 'Left Hand',
    rightHand: 'Right Hand',
    hips: 'Hips',
    pelvis: 'Pelvis',
    leftLeg: 'Left Leg',
    rightLeg: 'Right Leg',
    leftFoot: 'Left Foot',
    rightFoot: 'Right Foot',
    backBody: 'Back',
    shoulder: 'Shoulder',
    leftShoulder: 'Left Shoulder',
    rightShoulder: 'Right Shoulder',

    // Internal organs
    brain: 'Brain',
    throat: 'Throat',
    heart: 'Heart',
    leftLung: 'Left Lung',
    rightLung: 'Right Lung',
    lungs: 'Lungs',
    liver: 'Liver',
    stomachOrgan: 'Stomach',
    leftKidney: 'Left Kidney',
    rightKidney: 'Right Kidney',
    kidneys: 'Kidneys',
    intestines: 'Intestines',
    bladder: 'Bladder',

    // Pain scale
    noPain: 'No Pain',
    mildPain: 'Mild',
    moderatePain: 'Moderate',
    severePain: 'Severe',
    worstPain: 'Worst Pain',
    low: 'Low',
    currentPainLevel: 'Current Pain Level',
    painHistory: 'Pain History',
    recordPain: 'Record Pain',
    painLevel: 'Pain Level',

    // Sensation options
    sensationOptions: 'Sensation Type',
    selectSensations: 'What does it feel like?',
    selectedSensations: 'Selected sensations',
    burning: 'Burning',
    pressure: 'Pressure',
    sharp: 'Sharp',
    dull: 'Dull',
    throbbing: 'Throbbing',
    numbness: 'Numbness',
    tingling: 'Tingling',
    itching: 'Itching',
    nausea: 'Nausea',
    tightness: 'Tightness',

    // Help options
    howCanWeHelp: 'How can we help?',
    callNurse: 'Call Nurse',
    needMedicine: 'Need Medicine',
    changePosition: 'Change Position',
    icePack: 'Ice Pack',
    heatPack: 'Heat Pack',
    justRest: 'Just Rest',
    yourReport: 'Your report',
    location: 'Location',
    notSpecified: 'Not specified',

    // Medications
    addMedication: 'Add Medication',
    medicationName: 'Medication Name',
    dosage: 'Dosage',
    method: 'Method',
    oral: 'Oral',
    iv: 'IV',
    injection: 'Injection',
    topical: 'Topical',
    givenBy: 'Given By',
    frequency: 'Frequency',
    timestamp: 'Time',
    medicationHistory: 'Medication Log',
    noMedications: 'No medications logged yet',

    // Visitors
    addVisitor: 'Check In Visitor',
    visitorName: 'Visitor Name',
    visitorType: 'Visitor Type',
    nurse: 'Nurse',
    doctor: 'Doctor',
    family: 'Family',
    friend: 'Friend',
    other: 'Other',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    currentVisitors: 'Current Visitors',
    visitorHistory: 'Visitor Log',
    noVisitors: 'No visitors yet',
    inTime: 'IN',
    outTime: 'OUT',

    // Voice recognition
    voiceControl: 'Voice Control',
    tapToSpeak: 'Tap to Speak',
    listening: 'Listening...',
    voiceCommands: 'Voice Commands',
    sayEmergency: 'Say "Emergency" for help',
    sayPain: 'Say "Pain" to report pain',
    sayWater: 'Say "Water" when thirsty',

    // Comfort controls
    comfortControls: 'Comfort Controls',
    lights: 'Lights',
    volume: 'Volume',
    temperature: 'Temperature',
    fan: 'Fan',
    bedPosition: 'Bed Position',
    tv: 'TV',
    music: 'Music',
    blanket: 'Blanket',

    // Documents
    documents: 'Documents',
    addPhoto: 'Add Photo',
    photoGallery: 'Photo Gallery',
    noPhotos: 'No photos yet',
    viewPhoto: 'View Photo',
    deletePhoto: 'Delete Photo',

    // Dashboard
    caregiverDashboard: 'Caregiver Dashboard',
    patientStatus: 'Patient Status',
    stable: 'Stable',
    needsAttention: 'Needs Attention',
    critical: 'Critical',
    recentAlerts: 'Recent Alerts',
    activityLog: 'Activity Log',
    painTrend: 'Pain Trend',
    todaysSummary: "Today's Summary",
    noAlerts: 'No recent alerts',
    acknowledge: 'Acknowledge',

    // Reports
    generateReport: 'Generate Report',
    printReport: 'Print Report',
    downloadReport: 'Download Report',
    reportPeriod: 'Report Period',
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    customRange: 'Custom Range',

    // Kids mode
    kidsModeTitle: 'ECHO Kids',
    slothSays: 'Sammy the Sloth says:',
    slothGreeting: "Hi friend! I'm here to help you tell the grown-ups how you feel!",
    howDoYouFeel: 'How do you feel?',
    showMeWhere: 'Show me where it hurts!',
    greatJob: 'Great job telling me!',
    hiThere: 'Hi there! How do you feel?',
    helpMe: 'HELP ME!',
    ouchItHurts: 'Ouch! It hurts!',
    imFeelingGood: "I'm feeling good!",
    iWantWater: 'I want water',
    imHungry: "I'm hungry",
    bathroomPlease: 'Bathroom please',
    imCold: "I'm cold",
    imHot: "I'm hot",
    imSleepy: "I'm sleepy",
    imScared: "I'm scared",
    sammyProud: 'Sammy is proud of you!',

    // General
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    language: 'Language',
    english: 'English',
    spanish: 'Spanish',
    time: 'Time',
    date: 'Date',
    notes: 'Notes',
    addNote: 'Add Note',
    on: 'On',
    off: 'Off',
    submit: 'Submit',
    done: 'Done',

    // Voice accessibility
    voiceOn: 'Voice enabled',
    voiceOff: 'Voice disabled',
    soundOn: 'Sound enabled',
    soundOff: 'Sound disabled',
    kidsModeOn: 'Kids mode enabled',
    kidsModeOff: 'Kids mode disabled',
    languageChangedTo: 'Language changed to',
  },

  es: {
    // App title and navigation
    appTitle: 'ECHO',
    appSubtitle: 'Comunicación del Paciente',
    quickButtons: 'Botones Rápidos',
    bodyMap: 'Mapa Corporal',
    painScale: 'Escala de Dolor',
    sensations: 'Sensaciones',
    medications: 'Medicamentos',
    visitors: 'Visitantes',
    dashboard: 'Panel de Control',
    reports: 'Informes',
    kidsMode: 'Modo Niños',
    settings: 'Configuración',

    // Navigation labels
    navHome: 'Inicio',
    navBody: 'Cuerpo',
    navVoice: 'Voz',
    navComfort: 'Comodidad',
    navNotes: 'Notas',
    navDocs: 'Documentos',
    navVisitors: 'Visitantes',
    navMeds: 'Medicamentos',
    navDashboard: 'Panel',

    // Screen announcements
    screenHome: 'Pantalla de Inicio',
    screenBody: 'Pantalla del Mapa Corporal',
    screenVoice: 'Pantalla de Control de Voz',
    screenComfort: 'Pantalla de Controles de Comodidad',
    screenNotes: 'Pantalla de Notas',
    screenDocs: 'Pantalla de Documentos',
    screenVisitors: 'Pantalla de Registro de Visitantes',
    screenMeds: 'Pantalla de Seguimiento de Medicamentos',
    screenDashboard: 'Pantalla del Panel del Cuidador',

    // Quick button labels
    emergency: 'Emergencia',
    pain: 'Dolor',
    help: 'Ayuda',
    okay: 'Estoy Bien',
    thirsty: 'Sed',
    hungry: 'Hambre',
    bathroom: 'Baño',
    hot: 'Mucho Calor',
    cold: 'Mucho Frío',
    dizzy: 'Mareo',
    tired: 'Cansancio',
    anxious: 'Ansiedad',

    // Quick button descriptions
    emergencyDesc: '¡Necesito ayuda inmediata!',
    painDesc: 'Tengo dolor',
    helpDesc: 'Necesito asistencia',
    okayDesc: 'Estoy bien',
    thirstyDesc: 'Necesito agua',
    hungryDesc: 'Tengo hambre',
    bathroomDesc: 'Necesito ir al baño',
    hotDesc: 'Tengo mucho calor',
    coldDesc: 'Tengo mucho frío',
    dizzyDesc: 'Me siento mareado/a',
    tiredDesc: 'Estoy cansado/a',
    anxiousDesc: 'Me siento ansioso/a',

    // Body map
    selectBodyPart: 'Selecciona dónde te duele',
    externalBody: 'Cuerpo Externo',
    internalOrgans: 'Órganos Internos',
    tapToSelect: 'Toca una parte del cuerpo para seleccionar',
    selected: 'Seleccionado',

    // External body parts
    head: 'Cabeza',
    neck: 'Cuello',
    chest: 'Pecho',
    abdomen: 'Abdomen',
    stomach: 'Estómago',
    leftArm: 'Brazo Izquierdo',
    rightArm: 'Brazo Derecho',
    leftHand: 'Mano Izquierda',
    rightHand: 'Mano Derecha',
    hips: 'Caderas',
    pelvis: 'Pelvis',
    leftLeg: 'Pierna Izquierda',
    rightLeg: 'Pierna Derecha',
    leftFoot: 'Pie Izquierdo',
    rightFoot: 'Pie Derecho',
    backBody: 'Espalda',
    shoulder: 'Hombro',
    leftShoulder: 'Hombro Izquierdo',
    rightShoulder: 'Hombro Derecho',

    // Internal organs
    brain: 'Cerebro',
    throat: 'Garganta',
    heart: 'Corazón',
    leftLung: 'Pulmón Izquierdo',
    rightLung: 'Pulmón Derecho',
    lungs: 'Pulmones',
    liver: 'Hígado',
    stomachOrgan: 'Estómago',
    leftKidney: 'Riñón Izquierdo',
    rightKidney: 'Riñón Derecho',
    kidneys: 'Riñones',
    intestines: 'Intestinos',
    bladder: 'Vejiga',

    // Pain scale
    noPain: 'Sin Dolor',
    mildPain: 'Leve',
    moderatePain: 'Moderado',
    severePain: 'Severo',
    worstPain: 'Peor Dolor',
    low: 'Bajo',
    currentPainLevel: 'Nivel de Dolor Actual',
    painHistory: 'Historial de Dolor',
    recordPain: 'Registrar Dolor',
    painLevel: 'Nivel de Dolor',

    // Sensation options
    sensationOptions: 'Tipo de Sensación',
    selectSensations: '¿Cómo se siente?',
    selectedSensations: 'Sensaciones seleccionadas',
    burning: 'Ardor',
    pressure: 'Presión',
    sharp: 'Agudo',
    dull: 'Sordo',
    throbbing: 'Palpitante',
    numbness: 'Entumecimiento',
    tingling: 'Hormigueo',
    itching: 'Picazón',
    nausea: 'Náusea',
    tightness: 'Opresión',

    // Help options
    howCanWeHelp: '¿Cómo podemos ayudar?',
    callNurse: 'Llamar Enfermera',
    needMedicine: 'Necesito Medicina',
    changePosition: 'Cambiar Posición',
    icePack: 'Bolsa de Hielo',
    heatPack: 'Bolsa de Calor',
    justRest: 'Solo Descansar',
    yourReport: 'Tu reporte',
    location: 'Ubicación',
    notSpecified: 'No especificado',

    // Medications
    addMedication: 'Agregar Medicamento',
    medicationName: 'Nombre del Medicamento',
    dosage: 'Dosis',
    method: 'Método',
    oral: 'Oral',
    iv: 'IV',
    injection: 'Inyección',
    topical: 'Tópico',
    givenBy: 'Dado Por',
    frequency: 'Frecuencia',
    timestamp: 'Hora',
    medicationHistory: 'Registro de Medicamentos',
    noMedications: 'No hay medicamentos registrados',

    // Visitors
    addVisitor: 'Registrar Visitante',
    visitorName: 'Nombre del Visitante',
    visitorType: 'Tipo de Visitante',
    nurse: 'Enfermera',
    doctor: 'Doctor',
    family: 'Familia',
    friend: 'Amigo',
    other: 'Otro',
    checkIn: 'Entrada',
    checkOut: 'Salida',
    currentVisitors: 'Visitantes Actuales',
    visitorHistory: 'Registro de Visitantes',
    noVisitors: 'No hay visitantes aún',
    inTime: 'ENTRADA',
    outTime: 'SALIDA',

    // Voice recognition
    voiceControl: 'Control de Voz',
    tapToSpeak: 'Toca para Hablar',
    listening: 'Escuchando...',
    voiceCommands: 'Comandos de Voz',
    sayEmergency: 'Di "Emergencia" para ayuda',
    sayPain: 'Di "Dolor" para reportar dolor',
    sayWater: 'Di "Agua" cuando tengas sed',

    // Comfort controls
    comfortControls: 'Controles de Comodidad',
    lights: 'Luces',
    volume: 'Volumen',
    temperature: 'Temperatura',
    fan: 'Ventilador',
    bedPosition: 'Posición de Cama',
    tv: 'Televisión',
    music: 'Música',
    blanket: 'Cobija',

    // Documents
    documents: 'Documentos',
    addPhoto: 'Agregar Foto',
    photoGallery: 'Galería de Fotos',
    noPhotos: 'No hay fotos aún',
    viewPhoto: 'Ver Foto',
    deletePhoto: 'Eliminar Foto',

    // Dashboard
    caregiverDashboard: 'Panel del Cuidador',
    patientStatus: 'Estado del Paciente',
    stable: 'Estable',
    needsAttention: 'Necesita Atención',
    critical: 'Crítico',
    recentAlerts: 'Alertas Recientes',
    activityLog: 'Registro de Actividad',
    painTrend: 'Tendencia del Dolor',
    todaysSummary: 'Resumen del Día',
    noAlerts: 'No hay alertas recientes',
    acknowledge: 'Reconocer',

    // Reports
    generateReport: 'Generar Informe',
    printReport: 'Imprimir Informe',
    downloadReport: 'Descargar Informe',
    reportPeriod: 'Período del Informe',
    today: 'Hoy',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    customRange: 'Rango Personalizado',

    // Kids mode
    kidsModeTitle: 'ECHO Niños',
    slothSays: 'Sammy el Perezoso dice:',
    slothGreeting: '¡Hola amiguito! ¡Estoy aquí para ayudarte a decirle a los adultos cómo te sientes!',
    howDoYouFeel: '¿Cómo te sientes?',
    showMeWhere: '¡Muéstrame dónde te duele!',
    greatJob: '¡Muy bien por decirme!',
    hiThere: '¡Hola! ¿Cómo te sientes?',
    helpMe: '¡AYÚDAME!',
    ouchItHurts: '¡Ay! ¡Me duele!',
    imFeelingGood: '¡Me siento bien!',
    iWantWater: 'Quiero agua',
    imHungry: 'Tengo hambre',
    bathroomPlease: 'Baño por favor',
    imCold: 'Tengo frío',
    imHot: 'Tengo calor',
    imSleepy: 'Tengo sueño',
    imScared: 'Tengo miedo',
    sammyProud: '¡Sammy está orgulloso de ti!',

    // General
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    language: 'Idioma',
    english: 'Inglés',
    spanish: 'Español',
    time: 'Hora',
    date: 'Fecha',
    notes: 'Notas',
    addNote: 'Agregar Nota',
    on: 'Encendido',
    off: 'Apagado',
    submit: 'Enviar',
    done: 'Hecho',

    // Voice accessibility
    voiceOn: 'Voz activada',
    voiceOff: 'Voz desactivada',
    soundOn: 'Sonido activado',
    soundOff: 'Sonido desactivado',
    kidsModeOn: 'Modo niños activado',
    kidsModeOff: 'Modo niños desactivado',
    languageChangedTo: 'Idioma cambiado a',
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
